import script from "./MathLiveComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MathLiveComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MathLiveComponent.vue?vue&type=style&index=0&id=6ca765ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca765ec"]])

export default __exports__